var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25626 16.5938C3.13959 14.7098 2.74899 12.483 3.1578 10.3315C3.5666 8.17989 4.74669 6.25153 6.47652 4.90838C8.20636 3.56523 10.367 2.89967 12.5527 3.03666C14.7385 3.17364 16.7991 4.10374 18.3477 5.65235C19.8963 7.20095 20.8264 9.26157 20.9634 11.4473C21.1004 13.6331 20.4348 15.7937 19.0917 17.5236C17.7486 19.2534 15.8202 20.4335 13.6686 20.8423C11.5171 21.2511 9.29025 20.8605 7.40626 19.7438V19.7438L4.29376 20.6251C4.16624 20.6624 4.03103 20.6647 3.90231 20.6317C3.77359 20.5988 3.6561 20.5319 3.56215 20.4379C3.4682 20.344 3.40126 20.2265 3.36833 20.0978C3.33541 19.969 3.33771 19.8338 3.37501 19.7063L4.25626 16.5938Z",
    stroke: "#AAB0BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 12C12.875 12.4832 12.4832 12.875 12 12.875C11.5168 12.875 11.125 12.4832 11.125 12C11.125 11.5168 11.5168 11.125 12 11.125C12.4832 11.125 12.875 11.5168 12.875 12Z",
    fill: "#AAB0BF",
    stroke: "#AAB0BF",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 12C17.375 12.4832 16.9832 12.875 16.5 12.875C16.0168 12.875 15.625 12.4832 15.625 12C15.625 11.5168 16.0168 11.125 16.5 11.125C16.9832 11.125 17.375 11.5168 17.375 12Z",
    fill: "#AAB0BF",
    stroke: "#AAB0BF",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 12C8.375 12.4832 7.98325 12.875 7.5 12.875C7.01675 12.875 6.625 12.4832 6.625 12C6.625 11.5168 7.01675 11.125 7.5 11.125C7.98325 11.125 8.375 11.5168 8.375 12Z",
    fill: "#AAB0BF",
    stroke: "#AAB0BF",
    strokeWidth: 0.125
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.852d178ab342b3f351b37fd009b72856.svg";
export { ForwardRef as ReactComponent };